import {Brand} from "./brand.model";
import {Kpi} from "./kpi.model";
import {Grid} from "./grid.model";


export class Home {
    public dashboards : Kpi[];
    public kpis : Kpi[];
    public grids : Grid;
    public brand : Brand;
    
    constructor() {
        this.dashboards = [];
        this.kpis = [];
        this.grids = new Grid();
        this.brand = new Brand();     
    }
}
